
import { useEffect } from 'react';
import { useLoadingStrategy } from './LoadingStrategyProvider';
import { logFontLoadingMonitor } from '@/utils/consoleLogger';

export const FontLoadingMonitor = () => {
  const { markFontLoaded } = useLoadingStrategy();
  
  useEffect(() => {
    // Use the Font Loading API to monitor font status
    if ('fonts' in document) {
      document.fonts.ready.then(() => {
        logFontLoadingMonitor('All fonts successfully loaded');
        markFontLoaded();
        
        // Log individual font load status for debugging
        document.fonts.forEach(font => {
          logFontLoadingMonitor(`Font: ${font.family}, loaded: ${font.status === 'loaded'}`);
        });
      });
    } else {
      // Fallback for browsers not supporting Font Loading API
      // This timeout ensures we don't block rendering if fonts are slow
      const timeout = setTimeout(() => {
        logFontLoadingMonitor('Font loading timeout reached, marking as loaded');
        markFontLoaded();
      }, 2000);
      
      return () => clearTimeout(timeout);
    }
  }, [markFontLoaded]);
  
  return null;
};
